import * as React from 'react'
import styles from './style.module.css';
import { isEmpty } from "lodash";
import IconProvider from '../../../design-system/lib/IconProvider';
import Typography from '../../../design-system/lib/Typography';
 import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '../../../design-system/lib/Button';
import Input from '../../../design-system/lib/Input';
import Modal from '../../../design-system/lib/Modal';
import clsx from 'clsx';
import { DispatcherApi } from '../../../service/API/dispatcher';
import { get_id } from '../../../helper/UserData/userdate';
import { CLOSE, IMPORT_ICON  } from '../../../assets';
import { DownloadImage } from '../../../utils/downloadReactState';
import zIndex from 'newmaterial-ui/styles/zIndex';




function ImageViewer({ data, onclick }) {
  const { t } = useTranslation();
  const [dialoge, setDialoge] = React.useState(false);
  const [value, setValue] = React.useState("");




  React.useEffect(() => {

    try {
      document.addEventListener('ImageViewer', (e) => {

        console.log("dwddwwdwd",e)

        setValue(e.detail)

      })
      return () => {
        document.removeEventListener("ImageViewer", () => {

        });
      };
    } catch (error) {

    }
  }, [])


  return (
    <>

      {!isEmpty(value) && <div style={{position:"relative",left:"0px",top:"0px",zIndex:'5000000000',
         width: "100vw",  height: "100vh", backgroundColor:"rgba(0, 0, 0, 0.6)"
      }}>

        <Button size='Medium' onClick={()=>{
          setValue(null)
        }} type='Secondary' style={{backgroundColor:"white" ,marginTop:"16px",marginInlineStart :"16px",zIndex:"1"}} icon={CLOSE} />
        <Button size='Medium'  onClick={()=>{
           window.open(value , "_blanck")
        }}  type='Secondary' style={{backgroundColor:"white",marginTop:"16px",marginInlineStart :"16px",zIndex:"1"}} icon={IMPORT_ICON} />

       <img 
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                     position:"absolute",
                    top:"0px",
                    left:"0px"
                  }}
                  src={value}
                />
      </div>}
    </>

  )
}

export default ImageViewer